import React, { useEffect } from 'react'
import { optionalPrivacyActions } from '../../store/actions'
import { connect } from 'react-redux'

const Privacy = (props) => {
    const privacyViewer = document.querySelector('#optionalPrivacyViewer')

    useEffect(() => {
        props.load()
    }, [])

    useEffect(() => {
        if(props.privacyPage === true){
            props.priOptionSetting(
                props?.privacy?.data?.ptlTerms

            )
            props.optionSettings(
                props?.privacy?.data?.trmsHit

            )
        }else{

        }

    }, [props])

    let trmsCn = props?.privacy?.data?.trmsCn?.replaceAll('& ', '&')
    let trmsHit = "";

    useEffect(() => {
        for(var i in props?.privacy?.data?.trmsHit){

            if(props?.privacy?.data?.trmsHit[i].trmsSeq === props.select){
                trmsHit = props?.privacy?.data?.trmsHit[i].trmsCn.replaceAll('& ', '&')
            }
        }
    }, [props.select])


    useEffect(() => {
        if (privacyViewer !== null && privacyViewer !== undefined) {
            if(props.select?.length >= 1){
                privacyViewer.innerHTML = decodeHTMLEntities(trmsHit)
            }else{
                privacyViewer.innerHTML = decodeHTMLEntities(trmsCn)
            }
        }
    }, [props])

    return (
        <React.Fragment>
            <div id="optionalPrivacyViewer"></div>
        </React.Fragment>
    )
}

function decodeHTMLEntities(str) {
    let element = document.createElement('div')
    if (str && typeof str === 'string') {
        // strip script/html tags
        str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, '')
        str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, '')
        element.innerHTML = str
        str = element.textContent
        element.textContent = ''
    }

    return str
}

const mapStateToProps = (state) => {
    return { privacy: state.privacy }
}

const actionCreators = {
    load: optionalPrivacyActions.load,
}

export default connect(mapStateToProps, actionCreators)(Privacy)
